import { TextField, TextFieldProps } from '@material-ui/core'

const TextInput = (props: TextFieldProps) => <TextField variant="standard" {...props} />

export { TextInput }
